import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Bell, Check } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function NotificationsPage() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/notifications"); setItems(data); };
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.patch("/notifications/read-all"); load(); };
  const markOne = async (id) => { await api.patch(`/notifications/${id}/read`); load(); };
  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-4">
        <h1 className="font-display text-2xl font-bold">{t("notifications")}</h1>
        <Button data-testid="mark-all-read-btn" onClick={markAll} variant="outline" className="h-9 rounded-full text-sm"><Check size={15} className="mr-1" />{t("mark_read")}</Button>
      </div>
      {items.length === 0 ? (
        <div className="text-center text-neutral-400 py-16"><Bell size={32} className="mx-auto mb-2" /><p className="text-sm">{t("no_notifications")}</p></div>
      ) : (
        <div className="space-y-2">
          {items.map((n) => (
            <button key={n.id} data-testid={`notification-${n.id}`} onClick={() => markOne(n.id)}
              className={`w-full text-left border rounded-xl p-3 transition-colors ${n.read ? "border-neutral-200 bg-white" : "border-black bg-neutral-50"}`}>
              <div className="flex items-center justify-between">
                <p className="font-semibold text-sm">{n.title}</p>
                {!n.read && <span className="h-2 w-2 rounded-full bg-black" />}
              </div>
              <p className="text-xs text-neutral-500 mt-0.5">{n.body}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
